import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/krayonika-logo.png';
import './Home.css';

function Home() {
  return (
    <div className="hero-section text-center">
      <Container>
        <Row className="align-items-center">
          <Col>
            <img src={logo} alt="Krayonika Logo" className="hero-logo mb-4" />
            <h1 className="hero-title">Творческая студия Krayonika</h1>
            <p className="hero-subtitle">
              Уроки рисования для детей и взрослых, создание pop-up книг и иллюстраций.
            </p>
            <Button as={Link} to="/courses" variant="primary" size="lg">
              Смотреть курсы
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;